import React from "react";
import Box from "@mui/material/Box";
import { SxProps, Theme } from "@mui/material/styles";
import { EmtTypography } from "./EmtTypography";
import { EmtIcon } from "./EmtIcon";

export interface EmtClickBoxProps {
  value?: string;
  label?: string;
  iconClassName?: string;
  onClick?: () => void;
  sx?: SxProps<Theme>;
  variant?: "default" | "compact";
  iconLeftClassName?: string;
}

export const EmtClickBox: React.FC<EmtClickBoxProps> = ({
  value = "",
  label = "Lieu",
  iconClassName = "emt-right-1",
  onClick,
  sx = {},
  variant = "default",
  iconLeftClassName,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#fff",
        height: variant === "compact" ? "44px" : "100%",
        position: "relative",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        border: "1px solid",
        borderColor: "#F0F0F2",
        borderRadius: "16px",
        padding: "12px",
        justifyContent: "space-between",
        "& *": { cursor: "pointer!important" },
        "& .emt-icons": { fontSize: "14px!important" },
        ...sx,
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          maxWidth: "100%",
          minWidth: 0,
          display: "flex",
          alignItems: variant === "compact" ? "center" : "flex-start",
          flexDirection: variant === "compact" ? "row" : "column",
          gap: "4px",
          flex: 1,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {variant === "compact" && iconLeftClassName ? (
          <EmtIcon className={iconLeftClassName} />
        ) : (
          <EmtTypography variant="body2" sx={{ color: "#77757F" }}>
            {label}
          </EmtTypography>
        )}
        <EmtTypography
          variant="body2"
          fontWeight="700"
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: "1",
          }}
        >
          {value}
        </EmtTypography>
      </Box>
      <EmtIcon className={iconClassName} />
    </Box>
  );
};

EmtClickBox.displayName = "EmtClickBox";
